export function serializeType<T>(object: T) {
    return function () { return object; };
}
